import {
  FiCalendar,
  FiHelpCircle,
  FiMapPin,
  FiRefreshCw,
} from 'react-icons/fi';
import { type IconType } from 'react-icons';

import { dictionaries, useTranslation } from '@/i18n';

import Section from './Section';

const FAQ_ICONS: IconType[] = [FiMapPin, FiCalendar, FiHelpCircle, FiRefreshCw];

const FAQ = () => {
  const { locale, t } = useTranslation();
  const faqs = dictionaries[locale].home.faqs;

  return (
    <div className='mx-auto w-full max-w-2xl'>
      <div className='mb-6 flex flex-col items-center gap-4 text-center sm:mb-8'>
        <div
          aria-hidden
          className='flex w-full max-w-[220px] items-center gap-3'
        >
          <span className='h-px flex-1 bg-gradient-to-r from-transparent to-greenSecondary/45' />
          <span className='h-1 w-1 rounded-full bg-greenSecondary/70' />
          <span className='h-px flex-1 bg-gradient-to-l from-transparent to-greenSecondary/45' />
        </div>
        <h2 className='font-headings-semibold text-xl tracking-[-0.02em] text-backgroundGreen sm:text-2xl'>
          {t('home.faqTitle')}
        </h2>
      </div>

      <div className='flex flex-col gap-3 sm:gap-3.5'>
        {faqs.map((faq, idx) => {
          const Icon = FAQ_ICONS[idx] ?? FiHelpCircle;

          return (
            <Section
              key={`${faq.question}_${idx}`}
              answer={faq.answer}
              icon={Icon}
              index={idx}
              question={faq.question}
            />
          );
        })}
      </div>
    </div>
  );
};

export default FAQ;
